// --- Conteúdo FINAL: assets/calculadoraProduto-miner.js (V3 - Quai Corrigido) ---

document.addEventListener('DOMContentLoaded', () => {
  // --- 1. ELEMENTOS DO DOM ---
  const inputCustoKwh = document.getElementById('custo-kwh-input');
  
  // Elementos de Resultado
  const elResultadoEnergia = document.getElementById('resultado-energia');
  const elResultadoRendimento = document.getElementById('resultado-rendimento');
  const elIconeRendimento = document.getElementById('rendimento-icon-js'); 
   
  // Elementos de Dados do Produto
  const hashrateDisplayElement = document.getElementById('hashrate-display');
  const consumoDisplayElement = document.getElementById('consumo-display');
  
  // Seletores de moeda
  const botoesMoeda = document.querySelectorAll('.coin-selector-js');

  if (!elResultadoRendimento || !hashrateDisplayElement) return;

  // --- 2. PREPARAÇÃO DO TOOLTIP ---
  let tooltip = document.querySelector('.mining-tooltip');
  if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'mining-tooltip';
      tooltip.innerHTML = '...';
      document.body.appendChild(tooltip);
  }

  // --- 3. DADOS E API ---
  const apiUrl = 'https://proxy-cripto-br.vercel.app/api/crypto-data';
  let dadosCripto = null;
  let custoKwhGlobal = inputCustoKwh ? (parseFloat(inputCustoKwh.value.replace(',', '.')) || 0) : 0;

  const MAPA_NOMES = {
      'bch': 'bitcoincash', 'bitcoin-cash': 'bitcoincash',
      'quai': 'quai',
      'litecoin': 'litecoin', 'dogecoin': 'dogecoin',
      'bitcoin': 'bitcoin', 'kaspa': 'kaspa'
  };

  // --- 4. REGRAS DE CÁLCULO ---
  const COIN_RULES = {
      'bitcoin': (h, d) => calcSha256(h, d.redes.bitcoin, d.precos.bitcoin, 'Bitcoin'),
      'bitcoincash': (h, d) => calcSha256(h, d.redes.bitcoincash, d.precos.bitcoincash, 'BCH'),
      'kaspa': (h, d) => {
          const r = d.redes.kaspa, p = d.precos.kaspa;
          const c = (h / r.dificuldade) * r.recompensa_bloco * 86400;
          return { val: c * p, qtd: c, nome: 'KASPA' };
      },
      
      // [MUDANÇA 1] Nova Lógica Quai (Igual da Tabela)
      'quai': (h, d, isScrypt) => {
          // Seleciona a rede correta
          const rQuai = isScrypt ? d.redes.quai.scrypt : d.redes.quai.sha256;
          
          if (!rQuai) return { val: 0, qtd: 0, nome: 'QUAI (N/A)' };

          const preco = d.precos.quai || 0;
          const redeHashrate = rQuai.hashrate_rede || 1; 
          
          // Usa o tempo real (ou 1.3s fallback)
          const tempoBloco = rQuai.tempo_bloco || 1.3;

          const blocosPorDia = 86400 / tempoBloco;
          const emissaoDiaria = blocosPorDia * rQuai.recompensa_bloco;

          const minhaFatia = h / redeHashrate;
          const minhasMoedas = emissaoDiaria * minhaFatia;
          
          return { 
              val: minhasMoedas * preco, 
              qtd: minhasMoedas, 
              nome: 'QUAI' 
          };
      },
      
      'litecoin': (h, d) => calcScrypt(h, d),
      'dogecoin': (h, d) => calcScrypt(h, d)
  };

  // Funções Auxiliares
  function calcSha256(hash, rede, preco, nome) {
      const coins = (hash * rede.recompensa_bloco * 86400) / (rede.dificuldade * 4294967296);
      return { val: coins * preco, qtd: coins, nome: nome };
  }

  function calcScrypt(hash, dados) {
      const rLtc = dados.redes.litecoin, pLtc = dados.precos.litecoin;
      const rDoge = dados.redes.dogecoin, pDoge = dados.precos.dogecoin;
      const ltcC = (hash * rLtc.recompensa_bloco * 86400) / (rLtc.dificuldade * 4294967296);
      const dogeC = (hash * rDoge.recompensa_bloco * 86400) / (rDoge.dificuldade * 4294967296);
      return { val: (ltcC * pLtc) + (dogeC * pDoge), qtd: ltcC, nome: 'LTC + DOGE', isCombo: true, qtdSecundaria: dogeC };
  }

  // --- 5. LÓGICA PRINCIPAL ---

  async function iniciar() {
      elResultadoRendimento.innerText = 'Carregando...';
      try {
          const res = await fetch(apiUrl);
          if (!res.ok) throw new Error('Falha API');
          dadosCripto = await res.json();
          selecionarMelhorMoedaInicial();
      } catch (err) {
          console.error(err);
          elResultadoRendimento.innerText = 'Erro API';
      }
  }

  function selecionarMelhorMoedaInicial() {
      let candidatos = [];
      if (botoesMoeda.length > 0) {
          botoesMoeda.forEach(btn => {
              const handle = btn.dataset.coinHandle;
              if (handle) candidatos.push(handle);
          });
      } else {
          // Fallback lendo do dataset se não houver botões
          const str = hashrateDisplayElement.dataset.moeda || "";
          candidatos = str.split(',').map(s => s.trim()).filter(s => s);
      }

      let melhorLucro = -Infinity;
      let melhorHandle = candidatos[0] || 'bitcoin'; 

      candidatos.forEach(rawHandle => {
          const key = MAPA_NOMES[rawHandle] || rawHandle;
          const dados = calcularDadosMoeda(key);
          if (dados && dados.lucroDia > melhorLucro) {
              melhorLucro = dados.lucroDia;
              melhorHandle = rawHandle;
          }
      });

      atualizarInterfaceParaMoeda(melhorHandle);
  }

  // Função Central de Cálculo
  function calcularDadosMoeda(moedaKey) {
      if (!dadosCripto) return null;
      
      let hashrateBruto = parseFloat(hashrateDisplayElement.dataset.hashrate) || 0;
      
      // [MUDANÇA 2] Detector de Contexto (O Pulo do Gato)
      // Lemos todas as moedas suportadas pelo produto para saber se ele é Scrypt
      const todasMoedasDoProduto = (hashrateDisplayElement.dataset.moeda || "").toLowerCase();
      const isScrypt = todasMoedasDoProduto.includes('litecoin') || todasMoedasDoProduto.includes('dogecoin');

      // [MUDANÇA 3] Ajuste de Escala Baseado no Hardware
      // Se for máquina Scrypt: 1e9 (GH/s). Se for SHA: 1e12 (TH/s).
      let hashrateHS = hashrateBruto * (isScrypt ? 1e9 : 1e12);

      const consumoW = parseFloat(consumoDisplayElement.dataset.consumo) || 0;
      const custoDia = (consumoW / 1000) * custoKwhGlobal * 24;

      const regra = COIN_RULES[moedaKey];
      if (regra) {
          // Passamos o isScrypt para a regra (Vital para o Quai)
          const res = regra(hashrateHS, dadosCripto, isScrypt);
          const lucroDia = res.val - custoDia;
          return {
              lucroDia: lucroDia,
              lucroMes: lucroDia * 30,
              qtdMes: res.qtd * 30,
              nomeDisplay: res.nome,
              isCombo: res.isCombo,
              qtdSecundaria: (res.qtdSecundaria || 0) * 30
          };
      }
      return null;
  }

  function atualizarInterfaceParaMoeda(handleOriginal) {
      const key = MAPA_NOMES[handleOriginal] || handleOriginal;
      const dados = calcularDadosMoeda(key);

      if (!dados) return;
      
      // 1. Atualiza Texto de Lucro
      const cor = dados.lucroDia >= 0 ? '#2ecc71' : '#ff4444';
      elResultadoRendimento.innerHTML = `<span style="color:${cor}">${formatarReais(dados.lucroDia)} <small>/dia</small></span>`;

      // 2. Atualiza Texto de Energia
      if (elResultadoEnergia) {
           const consumoW = parseFloat(consumoDisplayElement.dataset.consumo) || 0;
           const custoDia = (consumoW / 1000) * custoKwhGlobal * 24;
           elResultadoEnergia.innerHTML = `<span style="color:#ff4500">${formatarReais(custoDia)} <small>/dia</small></span>`;
      }

      // 3. Troca de Ícone
      if (elIconeRendimento) {
          let btnAlvo = null;
          botoesMoeda.forEach(btn => { if (btn.dataset.coinHandle === handleOriginal) btnAlvo = btn; });
          
          if (btnAlvo) {
              const imgFonte = btnAlvo.querySelector('img');
              if (imgFonte) {
                  elIconeRendimento.src = imgFonte.src;
                  if(imgFonte.srcset) elIconeRendimento.srcset = imgFonte.srcset;
              }
          }
      }
      
      // 4. Destaque Visual Botões
      botoesMoeda.forEach(btn => {
          btn.style.boxSizing = 'border-box';
          if (btn.dataset.coinHandle === handleOriginal) {
              btn.style.opacity = '1'; 
              btn.style.border = ''; 
          } else {
              btn.style.opacity = '0.5'; 
              btn.style.border = ''; 
          }
      });
  }

  // --- 6. INTERAÇÃO ---
  botoesMoeda.forEach(btn => {
      btn.addEventListener('click', (e) => {
          e.preventDefault();
          atualizarInterfaceParaMoeda(btn.dataset.coinHandle);
      });

      btn.addEventListener('mouseenter', (e) => {
          const handle = btn.dataset.coinHandle;
          const key = MAPA_NOMES[handle] || handle;
          const dados = calcularDadosMoeda(key);

          if (!dados) return;

          let txtQtd = `${dados.qtdMes.toFixed(4)} ${dados.nomeDisplay}`;
          if (dados.isCombo) txtQtd = `${dados.qtdMes.toFixed(2)} LTC + ${dados.qtdSecundaria.toFixed(0)} DOGE`;
          const corValor = dados.lucroMes >= 0 ? '#2ecc71' : '#ff4444';

          tooltip.innerHTML = `
              <strong>${dados.nomeDisplay}</strong>
              <div class="tooltip-values" style="color: ${corValor}">
                  ${formatarReais(dados.lucroMes)} <small style="color:#fff; font-weight:normal">Liq./mês</small>
              </div>
              <div class="tooltip-coin-amount">Est: ${txtQtd}</div>
          `;
          tooltip.classList.add('visible');
          moverTooltip(e);
      });

      btn.addEventListener('mouseleave', () => { tooltip.classList.remove('visible'); });
      btn.addEventListener('mousemove', moverTooltip);
  });

  function moverTooltip(e) {
      tooltip.style.left = (e.clientX + 15) + 'px';
      tooltip.style.top = (e.clientY + 15) + 'px';
  }

  if (inputCustoKwh) {
      inputCustoKwh.addEventListener('input', () => {
          custoKwhGlobal = parseFloat(inputCustoKwh.value.replace(',', '.')) || 0;
          const activeBtn = document.querySelector('.coin-selector-js[style*="opacity: 1"]');
          if (activeBtn) {
              atualizarInterfaceParaMoeda(activeBtn.dataset.coinHandle);
          } else {
              selecionarMelhorMoedaInicial();
          }
      });
  }

  function formatarReais(v) { return `R$ ${v.toFixed(2).replace('.', ',')}`; }

  iniciar();
});